import React, { useState, useEffect, useRef } from 'react'
import { incidentalLoanService } from '../../services/incidentalLoanService'
import { settingsService } from '../../services/settingsService'

function IncidentalLoanSettings() {
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [coaList, setCoaList] = useState([])
  const selectRefs = useRef([])
  const [formData, setFormData] = useState({
    KodeAkunPinjaman: '',
    KodeAkunBunga: '',
    KodeAkunDenda: '',
    KodeAkunAdmin: '',
    Plafon: '',
    JangkaWaktu: '',
    PersentaseBunga: '',
    PersentaseDenda: '',
    PersentaseAdmin: '0',
    EnableProrata: false,
    StatusAktif: true
  })

  const fetchSettings = async () => {
    try {
      setLoading(true)
      const response = await incidentalLoanService.getSettings()
      const settingsList = response.data.data || []
      
      if (settingsList.length > 0) {
        const existingSettings = settingsList[0]
        setFormData({
          KodeAkunPinjaman: existingSettings.KodeAkunPinjaman || '',
          KodeAkunBunga: existingSettings.KodeAkunBunga || '',
          KodeAkunDenda: existingSettings.KodeAkunDenda || '',
          KodeAkunAdmin: existingSettings.KodeAkunAdmin || '',
          Plafon: existingSettings.Plafon || '',
          JangkaWaktu: existingSettings.JangkaWaktu || '',
          PersentaseBunga: existingSettings.PersentaseBunga || '',
          PersentaseDenda: existingSettings.PersentaseDenda || '',
          PersentaseAdmin: existingSettings.PersentaseAdmin || '0',
          EnableProrata: existingSettings.EnableProrata || false,
          StatusAktif: existingSettings.StatusAktif !== undefined ? existingSettings.StatusAktif : true
        })
      }
    } catch (error) {
      console.error('Error fetching settings:', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchCOA = async () => {
    try {
      const response = await settingsService.getCOA()
      let data = response.data.data
      // Handle nested data structure: response.data.data.data
      if (data && !Array.isArray(data) && Array.isArray(data.data)) {
        data = data.data
      }
      setCoaList(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Error fetching COA:', error)
      setCoaList([])
    }
  }

  useEffect(() => {
    fetchSettings()
    fetchCOA()
  }, [])

  useEffect(() => {
    // Initialize Select2 for all account dropdowns
    selectRefs.current.forEach((ref) => {
      if (ref) {
        // Check if Select2 is already initialized
        if ($(ref).data('select2')) {
          $(ref).select2('destroy')
        }
        
        // Initialize Select2
        $(ref).select2({
          placeholder: 'Pilih Kode Akun',
          allowClear: true,
          width: '100%'
        })

        // Set current value
        const fieldName = ref.getAttribute('data-field')
        if (formData[fieldName]) {
          $(ref).val(formData[fieldName]).trigger('change')
        }

        // Handle change event
        $(ref).on('change', (e) => {
          setFormData(prev => ({ ...prev, [fieldName]: e.target.value }))
        })
      }
    })

    // Cleanup
    return () => {
      selectRefs.current.forEach(ref => {
        if (ref && $(ref).data('select2')) {
          $(ref).off('change').select2('destroy')
        }
      })
    }
  }, [coaList, formData])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    
    try {
      const response = await incidentalLoanService.getSettings()
      const settingsList = response.data.data || []
      
      if (settingsList.length > 0) {
        await incidentalLoanService.updateSettings(settingsList[0].Id, formData)
        alert('Pengaturan berhasil diupdate')
      } else {
        await incidentalLoanService.createSettings(formData)
        alert('Pengaturan berhasil disimpan')
      }
    } catch (error) {
      alert(error.response?.data?.message || 'Gagal menyimpan pengaturan')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Pengaturan Pinjaman Insidentil</h3>
      </div>
      <div className="card-body">
        {loading ? (
          <div className="text-center">
            <i className="fas fa-spinner fa-spin fa-2x"></i>
            <p className="mt-3">Memuat data...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Kode Akun Pinjaman <span className="text-danger">*</span></label>
                  <select
                    ref={el => selectRefs.current[0] = el}
                    data-field="KodeAkunPinjaman"
                    className="form-control select2"
                    required
                  >
                    <option value="">Pilih Kode Akun</option>
                    {coaList.map((coa) => (
                      <option key={coa.KodeAkun} value={coa.KodeAkun}>
                        {coa.KodeAkun} - {coa.NamaAkun}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Kode Akun Bunga <span className="text-danger">*</span></label>
                  <select
                    ref={el => selectRefs.current[1] = el}
                    data-field="KodeAkunBunga"
                    className="form-control select2"
                    required
                  >
                    <option value="">Pilih Kode Akun</option>
                    {coaList.map((coa) => (
                      <option key={coa.KodeAkun} value={coa.KodeAkun}>
                        {coa.KodeAkun} - {coa.NamaAkun}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Kode Akun Denda <span className="text-danger">*</span></label>
                  <select
                    ref={el => selectRefs.current[2] = el}
                    data-field="KodeAkunDenda"
                    className="form-control select2"
                    required
                  >
                    <option value="">Pilih Kode Akun</option>
                    {coaList.map((coa) => (
                      <option key={coa.KodeAkun} value={coa.KodeAkun}>
                        {coa.KodeAkun} - {coa.NamaAkun}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Kode Akun Admin <span className="text-danger">*</span></label>
                  <select
                    ref={el => selectRefs.current[3] = el}
                    data-field="KodeAkunAdmin"
                    className="form-control select2"
                    required
                  >
                    <option value="">Pilih Kode Akun</option>
                    {coaList.map((coa) => (
                      <option key={coa.KodeAkun} value={coa.KodeAkun}>
                        {coa.KodeAkun} - {coa.NamaAkun}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Plafon <span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.Plafon}
                    onChange={(e) => setFormData({ ...formData, Plafon: e.target.value })}
                    min="0"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Jangka Waktu (bulan) <span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.JangkaWaktu}
                    onChange={(e) => setFormData({ ...formData, JangkaWaktu: e.target.value })}
                    min="1"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label>Persentase Bunga (% per tahun) <span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.PersentaseBunga}
                    onChange={(e) => setFormData({ ...formData, PersentaseBunga: e.target.value })}
                    min="0"
                    max="100"
                    step="0.01"
                    required
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Persentase Denda (% per bulan) <span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.PersentaseDenda}
                    onChange={(e) => setFormData({ ...formData, PersentaseDenda: e.target.value })}
                    min="0"
                    max="100"
                    step="0.01"
                    required
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Persentase Admin (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.PersentaseAdmin}
                    onChange={(e) => setFormData({ ...formData, PersentaseAdmin: e.target.value })}
                    min="0"
                    max="100"
                    step="0.01"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <div className="custom-control custom-switch">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="enableProrata"
                      checked={formData.EnableProrata}
                      onChange={(e) => setFormData({ ...formData, EnableProrata: e.target.checked })}
                    />
                    <label className="custom-control-label" htmlFor="enableProrata">
                      Enable Prorata
                    </label>
                  </div>
                  <small className="text-muted">
                    Jika diaktifkan, biaya admin akan dihitung secara prorata berdasarkan durasi pinjaman
                  </small>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="custom-control custom-switch">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="statusAktif"
                      checked={formData.StatusAktif}
                      onChange={(e) => setFormData({ ...formData, StatusAktif: e.target.checked })}
                    />
                    <label className="custom-control-label" htmlFor="statusAktif">
                      Status Aktif
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group">
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? (
                  <>
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Menyimpan...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save mr-2"></i>
                    Simpan Pengaturan
                  </>
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}

export default IncidentalLoanSettings
